var exports = {
  "W": "x31de4314--456469--dropdown",
};

module.exports = exports;
